import styled from 'styled-components'

import { media } from '../../../utils/mediaQuery'

export const ContentContainer = styled.div`
  padding: 26px;
  margin: 0 auto;

  ${media.tabletDown} {
    padding: 16px;
  }
`

export const AnalysisSectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-transform: capitalize;
`

export const PlaceholderContent = styled.div`
  background: white;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 38px;
  text-align: center;
  color: #999;
  font-size: 12px;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`

export const PlaceholderIcon = styled.div`
  font-size: 38px;
  opacity: 0.5;
`
